import { CircleAlert } from 'lucide-react'
import { TableInstallmentProps } from './types'

interface ModalChangeInstallmentProps {
  open: boolean
  onClose: () => void
  onSimulate: () => void
  selectedPrazo: number | undefined
  setSelectedPrazo: (value: number | undefined) => void
  table: TableInstallmentProps
}

const ModalChangeInstallment = ({
  open,
  onClose,
  onSimulate,
  selectedPrazo,
  setSelectedPrazo,
  table,
}: ModalChangeInstallmentProps) => {
  if (!open) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black01/40">
      <div className="relative mx-2 w-full max-w-md rounded-2xl bg-white01 p-6 shadow-xl">
        <div className="flex flex-col items-center">
          <CircleAlert className="h-12 w-12 text-primary" />
          <h2 className="my-2 text-center text-xl font-semibold">
            Escolha o número de parcelas que deseja antecipar
          </h2>
          <p className="mb-8 text-center text-sm font-medium text-black01">
            O valor do seu saque é calculado automaticamente com base na
            quantidade de parcelas que você escolher antecipar
          </p>
          <button
            className={`mb-4 w-full rounded-lg border border-primary bg-primary/10 py-2 font-semibold text-black01 ${selectedPrazo === undefined ? 'ring ring-primary' : ''}`}
            onClick={() => setSelectedPrazo(undefined)}
          >
            Maximo
          </button>
          <div className="mb-4 grid w-full grid-cols-2 gap-3">
            {Array.from({ length: table.Prazo ?? 0 }, (_, i) => (
              <button
                key={i + 1}
                className={`rounded-lg border border-gray02 bg-white01 py-3 font-semibold text-black01 ${selectedPrazo === i + 1 ? 'ring ring-primary' : ''}`}
                onClick={() => setSelectedPrazo(i + 1)}
              >
                {i + 1}X
              </button>
            ))}
          </div>
          <span className="mb-8 text-center text-sm font-medium text-black01">
            selecione a quantidade de parcelas que deseja antecipar e veja
            quanto pode sacar!
          </span>
          <button
            className="mb-4 w-full rounded-full bg-primary py-3 text-lg font-bold text-white01 disabled:opacity-60"
            onClick={onSimulate}
          >
            Simular novamente
          </button>
          <button
            className="w-full rounded-full bg-gray01 py-3 text-lg font-semibold text-black01"
            onClick={onClose}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  )
}

export default ModalChangeInstallment
